import React from 'react';
import { connect } from 'react-redux';
import { State } from 'store/state';
import { hostedFieldsBulletinIdSelector, isHostedFieldsFailModalOpenSelector } from 'store/state/app/selectors';
import { IconWrapper, TextArea, Title, Wrapper } from './styled';
import { setHostedFieldsFailModalAction, upgradeUserPlanFlow } from 'store/state/app/actions';
import { useLocale } from 'locale';
import FailIcon from 'assets/svg/fail-circle.svg';
import { Button } from 'ds/components/button';
import { ModalWrapper } from './Wrapper';
import { PrivateUserMonetizationSource } from 'store/state/app';


const FailModalBase: React.FC<{
  isOpen: boolean;
  bulletinId: string;
  setOpen: (isOpen: boolean) => void;
  onRetry: (data: { source: PrivateUserMonetizationSource; userInitiated: boolean; bulletinId: string | null }) => void;
}> = ({ isOpen, bulletinId, setOpen, onRetry }) => {
  const { t } = useLocale();

  const handleRetry = () => {
    setOpen(false);
    onRetry({
      source: PrivateUserMonetizationSource.HostedFieldsFailModal,
      userInitiated: true,
      bulletinId,
    });
  };

  return (
    <ModalWrapper isOpen={isOpen} onClose={() => setOpen(false)}>
      <Wrapper>
        <IconWrapper>
          <FailIcon />
        </IconWrapper>
        <Title>{t('payment.fail.modal.title')}</Title>
        <TextArea>{t('payment.fail.modal.text')}</TextArea>
        <Button mode="primary" size="extraLarge" onClick={handleRetry}>{t('payment.fail.modal.button')}</Button>
      </Wrapper>
    </ModalWrapper>
  );
};

const mapStateToProps = (state: State) => ({
  isOpen: isHostedFieldsFailModalOpenSelector(state),
  bulletinId: hostedFieldsBulletinIdSelector(state),
});

const mapDispatchToProps = {
  setOpen: setHostedFieldsFailModalAction,
  onRetry: upgradeUserPlanFlow,
};

export const PaymentFailModal = connect(mapStateToProps, mapDispatchToProps)(FailModalBase);
